import { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { useFirmContext } from '../providers/FirmProvider';
import queryClient from '../query-client';

export type UpdateSubscriptionV2Request = {
    interval?: string;
    activeEntities?: number;
};

async function updateSubscriptionV2(request: UpdateSubscriptionV2Request, firmId: string): Promise<void> {
    const { data } = await api.patch(`/firms/${firmId}/subscription/v2`, request);
    return data;
}

export function useUpdateSubscriptionV2(): UseMutationResult<void, AxiosError, UpdateSubscriptionV2Request, unknown> {
    const { id } = useFirmContext();
    return useMutation((req) => updateSubscriptionV2(req, id), {
        onSettled: () => {
            // The subscription will be invalidated via this first invalidation call
            queryClient.invalidateQueries(['firm', id]);
            queryClient.invalidateQueries(['upcoming-invoice']);
            queryClient.invalidateQueries(['payment-methods']);
            queryClient.invalidateQueries(['prior-invoices']);
        },
    });
}
